/** @type {import('tailwindcss').Config} */

export default {
  content: [
    './src/**/*.html',
    './src/**/*.{vue,js,ts}',
  ],
  theme: {
    colors: {
      grey: {
        100: '#F1F1F1',
        500: '#9E9E9E',
        900: '#333333',
      },
      black: '#000',
      white: '#FFF',
    },
    fontSize: {
      xs: '.75rem',
      s: '.8125rem',
      sm: '.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '2rem',
      '4xl': '2.5rem',
    },
    fontFamily: {
      base: 'system-ui, Arial, Helvetica, sans-serif',
    },
  },
};
